import { render, staticRenderFns } from "./winnerdialog.vue?vue&type=template&id=0208062a&"
import script from "./winnerdialog.vue?vue&type=script&lang=js&"
export * from "./winnerdialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build-wheel.7Tky5E/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0208062a')) {
      api.createRecord('0208062a', component.options)
    } else {
      api.reload('0208062a', component.options)
    }
    module.hot.accept("./winnerdialog.vue?vue&type=template&id=0208062a&", function () {
      api.rerender('0208062a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/winnerdialog.vue"
export default component.exports